// src/pages/ContactUs.js
import React from 'react';
import { Container } from 'react-bootstrap';
import ContactUs from '../components/Contactus';
const Contactus = () => {
  return (
  <ContactUs/>)
};

export default Contactus;
